module.exports = __webpack_public_path__ + "media/images/favicon/favicon-32x32-f37ebafb4145a970ceeb62b06449a856.png";